<template>
  <div style="height: 500px;" class="mt-4">  
      <v-chart class="chart" :option="option"  @ready="onReady" />
 </div>     
</template>
<script>

export default {
   components: {
    
  },
  name: 'chart-bar',
  data() {
    return {
      option : {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        toolbox: {
          feature: {
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ['line', 'bar'] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        
        xAxis: [
          {
            type: 'category',
            data: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul'],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: 'Anggaran',
            min: 0,
            max: 250,
            interval: 50,
            axisLabel: {
              formatter: '{value} Jt'
            }
          },
          {
            type: 'value',
            name: 'Persen',
            min: 0,
            max: 25,
            interval: 5,
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        series: [
          {
            name: 'SEKERTARIAT',
            type: 'bar',
            tooltip: {
             
            },
            data: [
              2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
            ]
          },
          {
            name: 'BIDANG MUTASI DAN PROMOSI',
            type: 'bar',
            tooltip: {
              
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          {
            name: 'BIDANG PENGADAAN, PEMBERHENTIAN DAN INFORMASI',
            type: 'bar',
            tooltip: {
              
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          {
            name: 'BIDANG PENGEMBANGAN KOMPETENSI APARATUR',
            type: 'bar',
            tooltip: {
              
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          {
            name: 'BIDANG PENILAIAN KINERJA APARATUR DAN PENGHARGAAN',
            type: 'bar',
            tooltip: {
              
            },
            data: [
              2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
            ]
          },
          /*
          {
            name: 'Temperature',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              
            },
            data: [2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2]
          }
          */
        ]
      }
    };
  },
  mounted: function () 
    {
      

    },
  methods : {
     onReady(instance) {
      this.ins = instance;
    },

   }
}
</script>


// WEBPACK FOOTER //
// src/components/Charts/Bar.vue